import './VifAnswerTile.scss';

export interface VifAnswerTileProps {
  answer: string;
  /** Legacy `preString`, rendered ahead of the answer. */
  preString?: string;
  /** Legacy `scaleVar === 2`. */
  large?: boolean;
  /** Rendered inside the drag overlay rather than in a cell. */
  overlay?: boolean;
  locked?: boolean;
}

/**
 * The bottom half of a tile: the draggable answer. Also rendered standalone
 * inside `DragOverlay`, which is the DOM stand-in for the canvas game's
 * floating `mPiece` (`mobilePiece`).
 */
export function VifAnswerTile({
  answer,
  preString = '',
  large = false,
  overlay = false,
  locked = false,
}: VifAnswerTileProps) {
  const classes = ['vif-answer-tile'];
  if (large) {
    classes.push('vif-answer-tile--large');
  }
  if (overlay) {
    classes.push('vif-answer-tile--overlay');
  }
  if (locked) {
    classes.push('vif-answer-tile--locked');
  }

  return (
    <span className={classes.join(' ')}>
      {preString}
      {answer}
    </span>
  );
}
